import React from 'react';

import { ReactComponent as MenuIco } from 'assets/nav-pane/menu.svg';

import styles from '../_app-container.module.scss';

type HomeBurger = React.ObjectHTMLAttributes<HTMLDivElement>;

export const AppBurger: React.FC<HomeBurger> = (props: HomeBurger) => {
  return (
    <div {...props} className={styles.Burger}>
      <MenuIco />
    </div>
  );
};
